/**
 * Input SĐT Việt Nam — tự format khoảng trắng khi gõ.
 */
import { formatPhoneInput } from '../../shared/utils/vietnamesePhone';

export const PhoneInput = ({
  value,
  onChange,
  required = false,
  placeholder = '0900 000 000',
  ...props
}) => {
  const handleChange = (event) => {
    onChange(formatPhoneInput(event.target.value));
  };

  return (
    <input
      type="tel"
      inputMode="numeric"
      autoComplete="tel"
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      maxLength={12}
      required={required}
      {...props}
    />
  );
};
